/**
 * Shell copy: the sidebar and top-bar navigation, the account controls and
 * the role names.
 */

export interface ShellCopy {
  readonly nav: {
    readonly dashboard: string;
    readonly tasks: string;
    readonly propose: string;
    readonly contributions: string;
    readonly dataRoom: string;
    readonly team: string;
    readonly ownerGroup: string;
    readonly help: string;
    readonly logout: string;
    readonly account: string;
    readonly mainNavigation: string;
    readonly roleBadge: (role: string) => string;
  };

  readonly roles: Readonly<Record<string, string>>;
}

export const SHELL_COPY_EN: ShellCopy = {
  nav: {
    dashboard: 'Dashboard',
    tasks: 'Task board',
    propose: 'Propose a task',
    contributions: 'Contributions',
    dataRoom: 'Data Room',
    team: 'Team and access',
    ownerGroup: 'Owner',
    help: 'Help',
    logout: 'Log out',
    account: 'Account',
    mainNavigation: 'Workspace',
    roleBadge: (role) => `Signed in as ${role}`,
  },

  roles: { OWNER: 'Owner', DEVELOPER: 'Developer', ANNOTATOR: 'Annotator' },
};

export const SHELL_COPY_AR: ShellCopy = {
  nav: {
    dashboard: 'لوحة العمل',
    tasks: 'لوحة المهام',
    propose: 'اقتراح مهمة',
    contributions: 'المساهمات',
    dataRoom: 'غرفة البيانات',
    team: 'الفريق والوصول',
    ownerGroup: 'المالك',
    help: 'المساعدة',
    logout: 'تسجيل الخروج',
    account: 'الحساب',
    mainNavigation: 'مساحة العمل',
    roleBadge: (role) => `مسجّل الدخول بصفة ${role}`,
  },

  roles: { OWNER: 'مالك', DEVELOPER: 'مطوّر', ANNOTATOR: 'مصنِّف' },
};
